import Vue from "vue";

const getDownloadConfig = () => {
  return Vue.$http.get("api/downloads/config/").then(res => {
    if (res && res.body) {
      return res.body;
    }
    if (res && res.data) {
      return res.data;
    }
    return res;
  });
};

export { getDownloadConfig };
